import React from 'react'
import { Alert } from 'reactstrap'

const naItem = (props) => (<Alert color='primary'><center><h3>Utilization data not available for <strong>{props.machine}</strong> at this time.</h3></center></Alert>)
export default naItem
